import React, { useState } from "react";
import BuddibleSocket, { MsgIDList } from "../../../lib/BuddibleSocket";
import Utilities from "../../../lib/Utilities";
import CodeList from "../../../lib/CodeList";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "Kodit";

export default function Kodit(props) {
  const { loginInfo } = props;
  const [text, setText] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();

  //프로모션 받아오기
  function search() {
    if (text.trim() === "") {
      codeList.Modal.current.alert(t("main.kodit.msg.enterBizNum"));
      return;
    }

    if (loginInfo === null) {
      codeList.Modal.current.alert(t("main.kodit.msg.requiresLogin"));
      return;
    }

    socket.fireLocalEventListener(
      MsgIDList.EVENT_LOGITALK_SEARCH_EXPORT_COMP_SELECT,
      _mClassName,
      text,
      () => {}
    );

    navigate("/LogiTalk", {
      state: {
        bizNum: text,
      },
    });
  }

  return (
    <div className="py-5" id="corpInfoReference">
      <div className="container margin_30">
        <div className="row m-0 p-0 rounded shadow-sm bg-white p-4 lineUp">
          <div className="col-12 col-lg-6 m-0 mb-3 mb-lg-0 p-0">
            <div className="h-100 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex flex-row align-items-center">
                  <p className="h4 font-weight-bold m-0 mr-2">
                    {t("main.kodit.title")}
                  </p>
                  <img
                    src="/img/main/kodit_logo.png"
                    height="30"
                    alt="kodit_logo"
                  />
                </div>
                <p className="h6 mt-2 mb-4">{t("main.kodit.description")}</p>
              </div>
              <div className="input-group mb-3">
                <input
                  className="form-control border border-width-2 border-freiscop rounded-0"
                  style={{ borderWidth: "3px !important" }}
                  placeholder={t("main.kodit.msg.enterBizNum")}
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.charCode === 13) {
                      search();
                    }
                  }}
                />

                <button
                  className="btn btn-sm rounded-0 text-white bg-freiscop border-freiscop"
                  onClick={search}
                >
                  <i className="fa-solid fa-magnifying-glass" />
                </button>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 m-0 p-0">
            <div className="d-flex flex-row align-items-center">
              <div>
                <div className="d-flex flex-column align-items-center mb-2">
                  <div className="position-relative">
                    <p className="b6 mb-0 text-danger font-weight-bold position-absolute authorship">
                      {t("main.kodit.source")}
                    </p>
                    <p className="h4 mb-0 text-freiscop font-weight-900 BM-DH">
                      BASA
                    </p>
                  </div>
                  <p>Business Analytics System on AI</p>
                </div>
                <div className="row m-0 px-md-5">
                  <div className="col-6 m-0 py-1 px-1">
                    <p className="bg-freiscop text-white font-weight-bold rounded-pill py-2 px-4 text-center">
                      {t("main.kodit.aiBusinessDiagnosis")}
                    </p>
                  </div>
                  <div className="col-6 m-0 py-1 px-1">
                    <p className="bg-freiscop text-white font-weight-bold rounded-pill py-2 px-4 text-center">
                      {t("main.kodit.financialInformation")}
                    </p>
                  </div>
                  <div className="col-6 m-0 py-1 px-1">
                    <p className="bg-freiscop text-white font-weight-bold rounded-pill py-2 px-4 text-center">
                      {t("main.kodit.clientInformation")}
                    </p>
                  </div>
                  <div className="col-6 m-0 py-1 px-1 h-100">
                    <p className="h-100 bg-freiscop text-white font-weight-bold rounded-pill py-2 px-4 text-center">
                      {t("main.kodit.creditRating")}
                    </p>
                  </div>
                </div>
              </div>
              <img
                className="d-none" // d-md-block
                src="/img/main/kodit_people.png"
                alt="kodit_people"
                height="160"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
